module.exports = __webpack_public_path__ + "resources/icon_44_up_small_active.97bf2405ca8796ee.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_up_small_active.png
// module id = 487
// module chunks = 0 1 2 3 4